import React from 'react';
import
{
    Dialog,
    DialogContent,
    DialogTitle,
    DialogActions,
    Box,
    Checkbox,
    FormGroup,
    FormControlLabel,
    IconButton,
    Tooltip,
} from '@mui/material';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import Title from '../title/title';

const flexItem = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',

}
// const Transition = React.forwardRef(function Transition(props, ref) {
//     return <Slide direction="up" ref={ref} {...props} />;
// });
const SettingCustomDialog = (props) =>
{
    const { handleClose, open, fullWidth } = props;


    return (
        <Dialog
            onClose={() => handleClose(false)}
            open={open}
            //TransitionComponent={props.showTransition && Transition}
            fullWidth={fullWidth}  {...props}>
            {props.title ? <Box sx={props.showCheckBox != undefined ? flexItem : null}><DialogTitle sx={{ pt: 1, pb: 1, pl: 3, pr: 3, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}><Title title={props.title} />
                {props.showCheckBox != undefined ? <Box component='div'> <FormGroup sx={{ ml: 6.5 }}><FormControlLabel control={<Checkbox
                    size='small'
                    checked={props.selected ? true : false}
                    onChange={(e) => props.onCheckSelect(e)}
                    // color="secondary"
                    disabled={
                        props.disableRow != undefined ? props.disableRow : false
                    }
                />} label="Select All" />  </FormGroup></Box> : null}
                {props.showClose === true ? <Box component='div'>
                    <Tooltip title='Close' >
                        <IconButton onClick={props.handleClose}>
                            <CloseOutlinedIcon />
                        </IconButton>
                    </Tooltip>
                </Box> : null}
            </DialogTitle> </Box> : null}
            <DialogContent dividers classes={props.dialogContentClasses ? props.dialogContentClasses : {}}>{props.renderContent()}
                {/* {props.snackBarProps.openSnack && (
                <CustomizedSnackbars
                    {...props.snackBarProps}
                    onClose={() =>
                        props.setSnackBarProps({ ...props.snackBarProps, openSnack: false })
                    }></CustomizedSnackbars>
            )} */}
                {/* <Box>{props.renderActions()}</Box> */}
            </DialogContent>
            <DialogActions>{props.renderActions()}</DialogActions>
        </Dialog>
    );
};
export default SettingCustomDialog;
